// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__JwVML","icon":"HeaderCartButton_icon__2cXuZ","badge":"HeaderCartButton_badge__TMmsX","bump":"HeaderCartButton_bump__N9jF3"};